import createReducer from 'common/redux/utils/createReducer';
import {
  REQUEST_FUNNEL,
  RECEIVE_FUNNEL,
  FUNNEL_RECEIVE_FAILED,
  SAVING_FUNNEL,
  FUNNEL_SAVE_FAILED,
} from 'funnel/actions/funnel';

const initialState = {
  isFetching: false,
  didInvalidate: false,
};

const funnel = createReducer(initialState, {
  [REQUEST_FUNNEL](state, action) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [RECEIVE_FUNNEL](state, { funnel }) {
    return {
      ...state,
      isFetching: false,
      funnel: funnel.funnel,
    };
  },
  [FUNNEL_RECEIVE_FAILED](state, { error }) {
    return {
      ...state,
      isFetching: false,
      receiveError: error,
    };
  },
  [SAVING_FUNNEL](state, { funnel }) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [FUNNEL_SAVE_FAILED](state, { error }) {
    return {
      ...state,
      isFetching: false,
      saveError: error,
    };
  },
});

export default funnel;



// WEBPACK FOOTER //
// ./src/modules/funnel/reducers/funnel.js